import React from 'react';
import LinearProgress from 'material-ui/LinearProgress'
import {grey200, indigo900} from 'material-ui/styles/colors'
import {AbsoluteCenter} from './StyledComponents'

const Progress = ({open, message}) => {
	if(open) {
		return <AbsoluteCenter style={{background: grey200, width: "100%", height: "100%", opacity: 0.5}}>
			<AbsoluteCenter style={{width: "25%", textAlign: "center"}}>
				<label style={{color:indigo900}}>{message}</label>
				<LinearProgress  style={{margin:8}} mode="indeterminate" />
			</AbsoluteCenter>
		</AbsoluteCenter>
	}
	return <div></div>
}

export default Progress


// WEBPACK FOOTER //
// ./src/components/Progress.js